<template>
  <div class="coupon-wrapper">
    <div>
      <img src="https://oss.aqdpay.com/appweb/psbcActive/millionRed/psbc_million_red_home.png" alt="" width="100%">
    </div>
    <div @click="goPsbcActiveHome" class="intro-tip"></div>
    <div class="intro-tip-2" @click="goIntro"></div>
    <div @click="goDrug" class="bottom"></div>
  </div>
</template>

<script>
import { getTaskUrl } from '@/api/active'
import { getDevice, setStore } from '@/utils/index'
export default {
  data () {
    return {
      accessToken: ''
    }
  },
  mounted () {
    this.accessToken = this.$route.query.accessToken
    if (this.accessToken) {
      console.log(this.accessToken)
      setStore('token', this.accessToken)
    } else {
      this.goLogin()
    }
  },
  methods: {
    goLogin () {
      /* eslint-disable */
      dsBridge.call('callLogin',function(res) {
        const token = res
        if (res) {
          setStore('token', token)
        }
      })
    },
    goIntro () {
      this.$router.push(`/psbcMillionRedCoupon?accessToken=${this.accessToken}`)
    },
    handleLook (appId) {
      getTaskUrl(appId).then((res) => {
        const data = res.data.result
        if (data) {
          // 跳转到原生界面
          /* eslint-disable */
          dsBridge.call('callNativeViewLifeCycle', {
            androidGoPage: data.androidGoPage,
            iosGoPage: data.iosGoPage,
            appId: data.appId,
            appType: data.appType,
            appStartUrl: data.appStartUrl,
            authorize: 0,
            addToolbar: data.addToolbar
          })
        } else {
          console.log('其他')
        }
      })
    },
    goPsbcActiveHome () {
      const device = getDevice()
      this.$router.push(`/psbcActiveHome?clientType=${device}&accessToken=${this.accessToken}`)
    },
    goDrug () {
      dsBridge.call('callNativeView', {
        androidGoPage: '/drug/DrugHomeActivity',
        iosGoPage: 'GXGYHomeViewController'
      })
    }
  }
}

</script>
<style lang='scss' scoped>

.coupon-wrapper {
  position: relative;
  min-height: 100vh;
  img {
    display: block;
    width: 100%;
  }
  .intro-tip {
    position: absolute;
    top: 25%;
    width: 100%;
    height: 12%;
  }
  .intro-tip-2 {
    position: absolute;
    top: 43%;
    width: 100%;
    height: 13%;
  }
  .bottom {
    position: absolute;
    bottom: 25%;
    width: 100%;
    height: 12%;
  }
}

</style>
